import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["username"],
  _excluded2 = ["username"];
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AvatarTemplate from "@Shared/@HandlebarsTemplates/general/avatar.hbs";
import { mapActions, mapState, mapGetters } from "vuex";
import { LOAD_CLIENT_APPLICATIONS, CHANGE_STARRED_CLIENT, LOAD_CLIENTS } from "../store/applications-list-actions";
import { CLIENTS_LOADED, APPLICATION_BY_ID } from "../store/applications-list-getters";
import ViewClientApplications from "./view-client-applications";
import AddToBoard from "./add-to-board";
import ViewOnBoard from "./view-on-board";
import { Event } from "@alexrafael10/vue-tables-2";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationsListTable",
  components: {
    ViewClientApplications,
    AddToBoard,
    ViewOnBoard,
    ProfileAvatar
  },
  props: {
    clients: {
      type: [Object, Array],
      default: () => ({})
    },
    allActionButtons: {
      type: Boolean,
      default: true
    },
    tableName: {
      type: String,
      required: true
    },
    copyingApp: {
      type: Boolean,
      default: false
    },
    card: {
      type: Boolean,
      default: true
    },
    showActionButtons: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updateKey: 0,
      openedRows: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationsListStore", ["agents"])), mapGetters("ApplicationsListStore", [CLIENTS_LOADED, APPLICATION_BY_ID])), {}, {
    getClients() {
      return Array.isArray(this.clients) ? this.clients : _Object$values(this.clients);
    },
    columns() {
      const tempColumns = ["username", "fullName", "email", "applicationStatus", "createdAt"];
      if (this.showActionButtons) tempColumns.push("actionbuttons");
      return tempColumns;
    },
    tableOptions() {
      return {
        uniqueKey: "username",
        hiddenColumns: "username",
        filterable: false,
        sortable: ["fullName", "email", "applicationStatus", "createdAt"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        columnsDisplay: {
          createdAt: "min_tablet"
        },
        showChildRowToggler: false,
        headings: {
          avatar: "",
          fullName: this.$t("tables.columns.fullName"),
          email: this.$t("tables.columns.email"),
          applicationStatus: this.$t("tables.columns.latestApplicationStatus"),
          createdAt: this.$t("tables.columns.latestApplicationCreatedAt"),
          actionbuttons: this.$t("global.words.actions")
        },
        perPage: 999999,
        tabbable: false,
        columnsClasses: this.showActionButtons ? {
          fullName: "w-20",
          email: "w-25",
          actionbuttons: "hidden-heading"
        } : {},
        skin: "table table-hover",
        customFilters: [{
          name: "searchClient",
          callback: (row, query) => {
            var _context;
            const fullName = `${row.givenName} ${row.familyName}`;
            return _indexOfInstanceProperty(_context = fullName.toLowerCase()).call(_context, query.toLowerCase()) >= 0;
          }
        }],
        sortingAlgorithm: data => data,
        rowClassCallback: row => {
          if (row.starred && this.allActionButtons) return "starred";
        },
        texts: {
          noResults: this.$t("tables.messages.emptyApplication")
        }
      };
    }
  }),
  mounted() {
    Event.$on("vue-tables.clients.sorted", ({
      column,
      ascending
    }) => {
      this.$emit("sort", {
        orderBy: column,
        orderType: ascending ? "ASC" : "DESC"
      });
    });
  },
  activated() {
    this.updateKey++;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [LOAD_CLIENT_APPLICATIONS, CHANGE_STARRED_CLIENT, LOAD_CLIENTS])), {}, {
    showApplications({
      username
    }, {
      target
    }) {
      this.toggleArrow(target);
      this.toggleRow(username);
    },
    toggleRow(username) {
      var _context2;
      if (_includesInstanceProperty(_context2 = this.openedRows).call(_context2, username)) {
        var _context3;
        this.openedRows = _filterInstanceProperty(_context3 = this.openedRows).call(_context3, row => row !== username);
      } else {
        this.openedRows.push(username);
      }
      this.$refs.clientTable.toggleChildRow(username);
    },
    closeOpenedRows() {
      this.openedRows.forEach(username => {
        this.$refs.clientTable.toggleChildRow(username);
      });
      this.openedRows = [];
    },
    createAdditionalApp(_ref) {
      let {
          username: clientUsername
        } = _ref,
        clientDetails = _objectWithoutProperties(_ref, _excluded);
      this.$emit("new-app", {
        clientUsername,
        method: "full-application-method",
        clientDetails,
        additional: true
      });
    },
    openModal(modalData, _ref2) {
      let {
          username: clientUsername
        } = _ref2,
        clientDetails = _objectWithoutProperties(_ref2, _excluded2);
      this.$emit("open-modal", {
        clientUsername,
        clientDetails,
        modalData
      });
    },
    getBadgeText(row) {
      return !isEmpty(row.coBrokeredFrom) ? this.$t("application.coBrokered") : this.$t("application.new");
    },
    async toggleStarredClient(clientUsername, agentUsername) {
      this.$parent.loadingTable = true;
      this.updateKey++;
      await this.CHANGE_STARRED_CLIENT({
        clientUsername
      });
      await this.LOAD_CLIENTS({
        agentUsername,
        limit: this.CLIENTS_LOADED,
        partial: true
      });
      this.$parent.loadingTable = false;
    },
    renderAvatar(client) {
      return AvatarTemplate(client);
    },
    latestAppLink({
      username: clientUsername,
      agentUsername,
      latestApplicationId: applicationId
    }) {
      return {
        name: "application",
        params: {
          agentUsername,
          clientUsername,
          applicationId
        }
      };
    },
    toggleArrow(target) {
      var _context4;
      const icon = _findInstanceProperty(_context4 = $(target)).call(_context4, "i");
      icon.toggleClass("fa-caret-down fa-caret-up");
    },
    formatStatus(applicationStatus) {
      return this.$options.filters.applicationStatus(applicationStatus);
    },
    getApplicationCreatedAt({
      latestApplicationId,
      applications
    }) {
      var _this$APPLICATION_BY_;
      const {
        createdAt
      } = (_this$APPLICATION_BY_ = this.APPLICATION_BY_ID(latestApplicationId)) != null ? _this$APPLICATION_BY_ : _findInstanceProperty(applications).call(applications, app => app.applicationId === latestApplicationId);
      return createdAt;
    },
    getNameToShow({
      latestApplicationId,
      givenName,
      familyName
    }) {
      var _this$APPLICATION_BY_2, _this$APPLICATION_BY_3;
      return (_this$APPLICATION_BY_2 = (_this$APPLICATION_BY_3 = this.APPLICATION_BY_ID(latestApplicationId)) == null ? void 0 : _this$APPLICATION_BY_3.mainApplicantName) != null ? _this$APPLICATION_BY_2 : `${givenName} ${familyName}`;
    },
    getInfoToShow(row) {
      const names = this.getNameToShow(row).split(" ");
      if (names.length > 2) {
        return {
          givenName: names[0],
          familyName: names[names.length - 1]
        };
      }
      const [givenName, familyName] = this.getNameToShow(row).split(" ");
      return {
        givenName,
        familyName
      };
    },
    avatarInitials(row) {
      var _givenName$trim, _givenName$trim$, _familyName$trim, _familyName$trim$;
      const {
        givenName,
        familyName
      } = this.getInfoToShow(row);
      return `${(givenName == null ? void 0 : (_givenName$trim = _trimInstanceProperty(givenName).call(givenName)) == null ? void 0 : (_givenName$trim$ = _givenName$trim[0]) == null ? void 0 : _givenName$trim$.toUpperCase()) || ""}${(familyName == null ? void 0 : (_familyName$trim = _trimInstanceProperty(familyName).call(familyName)) == null ? void 0 : (_familyName$trim$ = _familyName$trim[0]) == null ? void 0 : _familyName$trim$.toUpperCase()) || ""}`;
    },
    getIconElements({
      applicationStatus,
      accountStatus,
      verified
    }) {
      if (accountStatus === "ghost") {
        return {
          tooltip: "",
          icon: "",
          color: ""
        };
      }
      if (verified) {
        return {
          tooltip: this.$t("global.messages.clientIsRegisteredInPlatform"),
          icon: "how_to_reg",
          color: "text-primary"
        };
      }
      if (applicationStatus !== "pending") {
        return {
          tooltip: this.$t("global.messages.clientIsRegisteredButNotValidate"),
          icon: "person",
          color: "text-primary"
        };
      }
      if (accountStatus === "active") {
        return {
          tooltip: this.$t("global.messages.clientIsRegisteredButNotSubmittedApp"),
          icon: "person",
          color: "text-secondary"
        };
      }
      return {
        tooltip: "",
        icon: "",
        color: ""
      };
    }
  })
});